export const DEFAULT_CURRENT_PAGE = 1

export const DEFAULT_PAGE_SIZE = '10'
export const PAGE_SIZES = [DEFAULT_PAGE_SIZE, '20', '50']

export const PAGE_SIZE_OPTIONS = PAGE_SIZES.map((countOption: string) => ({
  label: countOption,
  value: countOption,
}))
